/**
 * The active locale, in the browser.
 *
 * Reads `<html lang>`, which the locale layout renders from the URL segment.
 * That is the same value next-intl resolved for the page, so a fetch made from
 * a component can never disagree with the page it was made from.
 *
 * This replaces `localStorage.getItem('hamishon-language')`, which the removed
 * glossary provider used to write. Nothing writes that key any more, so the
 * reads would have silently returned null and every authenticated API call
 * would have come back in Persian regardless of the page's language.
 */
export function getClientLocale(): string | undefined {
  if (typeof document === 'undefined') return undefined
  const lang = document.documentElement.lang?.trim()
  return lang || undefined
}
